var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [_vm._v("\n        Add Alias\n      ")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pb-0" },
            [
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("MonitoringFeatureAlias.aliasCanContainDataMsg")
                    ) +
                    " "
                ),
                _c("br"),
                _vm._v(
                  "\n        Aliases can assign metadata to imported data based on the alias type selected below.\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _c("strong", [_vm._v("Alias Type")]),
                _vm._v(" of new alias:\n      "),
              ]),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-2",
                  attrs: { "hide-details": "" },
                  model: {
                    value: _vm.mergeOutcome,
                    callback: function ($$v) {
                      _vm.mergeOutcome = $$v
                    },
                    expression: "mergeOutcome",
                  },
                },
                [
                  _c("v-radio", {
                    staticClass: "primary--text",
                    attrs: {
                      color: "info",
                      label: "Regular alias",
                      value: _vm.MERGE_OUTCOMES.becomeAlias,
                    },
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      color: "info",
                      label: "QA/QC alias",
                      value: _vm.MERGE_OUTCOMES.becomeQAQCAlias,
                    },
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      color: "info",
                      label: "Depth/Height alias",
                      value: _vm.MERGE_OUTCOMES.becomeDepthHeightAlias,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dialog
            ? _c("AddAliasForm", {
                ref: "form",
                attrs: {
                  givenStation: _vm.currentDiscreteStation,
                  nonPrimaryGivenStationAliases: _vm.nonPrimaryAliases,
                  isQaQc: _vm.mergeParameters.isQaQc,
                  isDepthHeightDatum: _vm.mergeParameters.isDepthHeightDatum,
                  valid: _vm.formIsValid,
                },
                on: {
                  "update:valid": function ($event) {
                    _vm.formIsValid = $event
                  },
                  close: function ($event) {
                    return _vm.close()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    loading: _vm.loading,
                    disabled: !_vm.formIsValid,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                  _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { outline: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }